module.exports = __webpack_public_path__ + "img/164.b1ccb90b.jpg";